// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__29Hbg","choiceBoxes":"toolbarselects_choiceBoxes__3Cd24","simpleField":"toolbarselects_simpleField__1ajtQ"};